/**
 * This file is auto-generated before every build.
 *
 * ! DO NOT EDIT THIS FILE MANUALLY !
 */

/**
 * The printable name of the package.
 */
export const OWCC_APP_NAME = 'owcc';

/**
 * The description of the package.
 */
export const OWCC_APP_DESCRIPTION = 'OneWeb Car Configurator';

/**
 * The current version of the package.
 */
export const OWCC_APP_VERSION = '2.250506.155740';

/**
 * The current commit hash.
 */
export const OWCC_APP_HASH = 'b05303a';

/**
 * The current workbench version defined in package dependencies.
 */
export const OWCC_WORKBENCH_VERSION = '7.35.1';

/**
 * Whether console output should be suppressed during tests.
 */
export const OWCC_NO_CONSOLE_OUTPUT_IN_TESTS = false;
